/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/img-redundant-alt */
// eslint-disable-next-lin

import React, { useState, useEffect, useRef } from "react";
import Header from "../layout/Header";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { useForm, Controller } from "react-hook-form";
import { InputNumber } from "primereact/inputnumber";
import { classNames } from "primereact/utils";
import { Button } from "primereact/button";
import { Image } from "primereact/image";
import { Sidebar } from "primereact/sidebar";
import { Dropdown } from "primereact/dropdown";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { Accordion, AccordionTab } from "primereact/accordion";

import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { FormErrorMessage, FormLabel } from "../GeneralComponent";

import { getMushaf } from "../../service/MushafService";
import { getPage } from "../../service/PageService";
import { getPageImage } from "../../service/PageImageService";
import { getCoordType } from "../../service/CoordTypeService";
import { getAyat } from "../../service/AyatService";
import { getMaqta } from "../../service/MaqtaService";
import { getMaqra } from "../../service/MaqraService";
import {
  getCoord,
  checkCoord,
  createCoord,
  deleteCoord,
} from "../../service/CoordService";
import { Paginator } from "primereact/paginator";
import { Checkbox } from "primereact/checkbox";

function hexToRgba(hex, alpha) {
  // Hilangkan '#' jika ada
  hex = hex.replace("#", "");

  // Parse r, g, b
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export default function Indexing(props) {
  const [bearertoken, setBearerToken] = useState(props.token);
  const [ltrb, setLTRB] = useState({ l: 0, t: 0, r: 0, b: 0 });
  const [ltrb_percentage, setLTRB_Percentage] = useState({
    l: 0,
    t: 0,
    r: 0,
    b: 0,
  });
  const [crop, setCrop] = useState({});

  const imageRef = useRef(null);
  const [previewUrl, setPreviewUrl] = useState("");
  const [imageFound, setImageFound] = useState(false);

  const [showPreview, setShowPreview] = useState(false);
  const [showIndexing, setShowIndexing] = useState(false);

  const [disableFormAyat, setDisableFormAyat] = useState(true);
  const [disableFormMaqta, setDisableFormMaqta] = useState(true);
  const [disableFormMaqra, setDisableFormMaqra] = useState(true);
  const [disableFormSequence, setDisableFormSequence] = useState(true);

  const [dataCoord, setDataCoord] = useState(null);
  const [selectedCoord, setSelectedCoord] = useState(null);

  const [dataMushaf, setDataMushaf] = useState(null);
  const [dataPage, setDataPage] = useState(null);
  const [dataAyat, setDataAyat] = useState(null);
  const [dataMaqta, setDataMaqta] = useState(null);
  const [dataMaqra, setDataMaqra] = useState(null);
  const [dataPageImage, setDataPageImage] = useState(null);
  const [dataCoordType, setDataCoordType] = useState(null);

  const [optionShowPreview, setOptionShowPreview] = useState(false);
  const [showAyatId, setShowAyatId] = useState(false);
  const [showAyatNumber, setShowAyatNumber] = useState(false);
  const [showSequence, setShowSequence] = useState(false);

  const toast = useRef(null);

  // ==================== REACT HOOK FORM FILTER [END] ====================

  // ==================== REACT HOOK FORM CRUD ====================
  const schema = yup
    .object()
    .shape({
      coord_mushaf: yup.object().required("Field Mushaf wajib diisi!"),
      coord_page: yup.object().required("Field Halaman wajib diisi!"),
      coord_type: yup.object().required("Field Tipe Koordinat wajib diisi!"),
      coord_left: yup
        .number()
        .nullable()
        .required("Field Koordinate Kiri wajib diisi!"),
      coord_right: yup
        .number()
        .nullable()
        .required("Field Koordinate Kanan wajib diisi!"),
      coord_top: yup
        .number()
        .nullable()
        .required("Field Koordinate Atas wajib diisi!"),
      coord_bottom: yup
        .number()
        .nullable()
        .required("Field Koordinate Bawah wajib diisi!"),
      // coord_ayat: yup.object().nullable().required("Field Ayat wajib diisi!"),
      // coord_sequence: yup
      //   .number()
      //   .nullable()
      //   .required("Field Urutan wajib diisi!"),
      coord_ayat: yup.object().when("coord_type", {
        is: (value) =>
          value &&
          (value.coordt_code === "AYAT" ||
            value.coordt_code === "AYAT-FIRST" ||
            value.coordt_code === "AYAT-LAST"),
        then: yup.object().nullable().required("Field Ayat wajib diisi!"),
        otherwise: yup.object().nullable(),
      }),
      coord_maqta: yup.object().when("coord_type", {
        is: (value) =>
          value &&
          (value.coordt_code === "MAQTA" ||
            value.coordt_code === "MAQTA-FIRST" ||
            value.coordt_code === "MAQTA-LAST" ||
            value.coordt_code === "MAQTA-BODY"),
        then: yup.object().nullable().required("Field Maqta wajib diisi!"),
        otherwise: yup.object().nullable(),
      }),
      coord_maqra: yup.object().when("coord_type", {
        is: (value) => value && value.coordt_code === "MAQRA",
        then: yup.object().nullable().required("Field Maqra wajib diisi!"),
        otherwise: yup.object().nullable(),
      }),
      coord_sequence: yup.number().when("coord_type", {
        is: (value) =>
          value &&
          (value.coordt_code === "AYAT" ||
            value.coordt_code === "MAQTA" ||
            value.coordt_code === "MAQTA-BODY" ||
            value.coordt_code === "MAQRA"),
        then: yup.number().nullable().required("Field Urutan wajib diisi!"),
        otherwise: yup.number().nullable(),
      }),
    })
    .required();

  const {
    control,
    watch,
    trigger,
    setValue,
    getValues,
    // handleSubmit,
    // reset,
    resetField,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      coord_ayat: null,
      coord_maqta: null,
      coord_maqra: null,
    },
  });

  const saveCoord = (data) => {
    (async () => {
      try {
        const result = await createCoord(data, bearertoken);

        if (result.status_code === 200) {
          toast.current.show({
            severity: "success",
            summary: "Sukses",
            detail: result.message,
            life: 1500,
          });
        } else {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: result.message,
            life: 1500,
          });
        }

        await getCoord({
          bearertoken: bearertoken,
          mushaf: watchCoordMushaf,
          page: watchCoordPage,
          coord_type: watchCoordType,
        })
          .then((response) => {
            setDataCoord(response.data);
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.log(error);

        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: error,
          life: 1500,
        });
      }
    })();
  };

  const hapusCoord = (data) => {
    (async () => {
      try {
        await deleteCoord(data, bearertoken)
          .then((response) => {
            toast.current.show({
              severity: "success",
              summary: "Success",
              detail: "Data Berhasil Dihapus!",
              life: 1500,
            });
          })
          .catch((error) => {
            console.log(error);

            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: error,
              life: 1500,
            });
          });

        await getCoord({
          bearertoken: bearertoken,
          mushaf: watchCoordMushaf,
          page: watchCoordPage,
          coord_type: watchCoordType,
        })
          .then((response) => {
            setDataCoord(response.data);
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.log(error);

        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: error,
          life: 1500,
        });
      }
    })();
  };

  const reject = () => {
    toast.current.show({
      severity: "warn",
      summary: "Dibatalkan",
      detail: "Data batal disimpan!",
      life: 1500,
    });
  };

  const SubmitCoord = (event) => {
    (async () => {
      const validasi = await trigger();
      if (validasi) {
        const data = getValues();

        await checkCoord(data, bearertoken)
          .then((response) => {
            if (response.data !== null) {
              confirmDialog({
                message:
                  "Data indexing sudah ada. Apakah kamu yakin ingin menimpa dengan data yang baru? Proses ini akan mengganti data yang ada dengan data yang baru.",
                header: "Konfirmasi",
                icon: "pi pi-exclamation-triangle",
                accept: () => saveCoord(data),
                reject,
              });
            } else {
              saveCoord(data);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    })();
  };

  const DeleteCoord = (event) => {
    (async () => {
      const validasi = await trigger();
      if (validasi) {
        const data = getValues();

        await checkCoord(data, bearertoken)
          .then((response) => {
            if (response.data !== null) {
              confirmDialog({
                message: "Apakah kamu yakin ingin menghapus data ini?",
                header: "Konfirmasi",
                icon: "pi pi-exclamation-triangle",
                accept: () => hapusCoord(data),
                reject,
              });
            } else {
              // saveCoord(data);
              console.log("data belum ada");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    })();
  };

  const watchCoordMushaf = watch("coord_mushaf");
  const watchCoordPage = watch("coord_page");
  const watchCoordType = watch("coord_type");
  const watchCoordLeft = watch("coord_left");
  const watchCoordRight = watch("coord_right");
  const watchCoordTop = watch("coord_top");
  const watchCoordBottom = watch("coord_bottom");
  // ==================== REACT HOOK FORM CRUD [END] ====================

  useEffect(() => {
    imageRef.current = document.getElementById("my-image");

    if (imageRef.current !== null) {
      setImageFound(true);
    }
  }, [dataPageImage]);

  useEffect(() => {
    (async () => {
      try {
        await getMushaf({ bearertoken: bearertoken })
          .then((response) => {
            setDataMushaf(response.data);
          })
          .catch((error) => {
            console.log(error);
          });

        await getPage({ bearertoken: bearertoken })
          .then((response) => {
            setDataPage(response.data);
          })
          .catch((error) => {
            console.log(error);
          });

        await getCoordType({ bearertoken: bearertoken })
          .then((response) => {
            setDataCoordType(response.data);
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  useEffect(() => {
    setShowPreview(false);
    imageRef.current = null;
    setImageFound(false);
    setCrop({});
    setLTRB({ l: 0, t: 0, r: 0, b: 0 });
    setLTRB_Percentage({ l: 0, t: 0, r: 0, b: 0 });

    // Reset Field
    setValue("coord_aspect_ratio", null);
    setValue("coord_ayat", null);
    setValue("coord_bottom", null);
    setValue("coord_height", null);
    setValue("coord_left", null);
    setValue("coord_right", null);
    setValue("coord_sequence", null);
    setValue("coord_top", null);
    setValue("coord_width", null);
    setValue("coord_bottom_percentage", null);
    setValue("coord_left_percentage", null);
    setValue("coord_right_percentage", null);
    setValue("coord_top_percentage", null);

    if (
      watchCoordMushaf !== null &&
      watchCoordMushaf !== undefined &&
      watchCoordPage !== null &&
      watchCoordPage !== undefined
    ) {
      (async () => {
        try {
          await getPageImage({
            bearertoken: bearertoken,
            mushaf: watchCoordMushaf,
            page: watchCoordPage,
          })
            .then((response) => {
              setDataPageImage(response.data);
            })
            .catch((error) => {
              console.log(error);
            });
        } catch (error) {
          console.log(error);
        }
      })();
    }
  }, [watchCoordMushaf, watchCoordPage]);

  useEffect(() => {
    if (watchCoordPage !== null && watchCoordPage !== undefined) {
      (async () => {
        try {
          await getAyat({ bearertoken: bearertoken, page: watchCoordPage })
            .then((response) => {
              setDataAyat(response.data);
            })
            .catch((error) => {
              console.log(error);
            });

          await getMaqta({ bearertoken: bearertoken, page: watchCoordPage })
            .then((response) => {
              setDataMaqta(response.data);
            })
            .catch((error) => {
              console.log(error);
            });

          await getMaqra({ bearertoken: bearertoken, page: watchCoordPage })
            .then((response) => {
              setDataMaqra(response.data);
            })
            .catch((error) => {
              console.log(error);
            });
        } catch (error) {
          console.log(error);
        }
      })();
    }
  }, [watchCoordPage]);

  useEffect(() => {
    if (selectedCoord !== null && imageRef.current) {
      (async () => {
        try {
          const coordinate = {
            x: (selectedCoord.coord_left * imageRef.current.width) / 100,
            y: (selectedCoord.coord_top * imageRef.current.height) / 100,
            width:
              ((selectedCoord.coord_right - selectedCoord.coord_left) *
                imageRef.current.width) /
              100,
            height:
              ((selectedCoord.coord_bottom - selectedCoord.coord_top) *
                imageRef.current.height) /
              100,
            unit: "px",
          };

          handleCropComplete(coordinate);

          const temp_ayat =
            dataAyat !== null
              ? dataAyat.find(
                  (item) => item.ayat_id === selectedCoord.coord_ayat
                )
              : null;
          const temp_maqta =
            dataMaqta !== null
              ? dataMaqta.find(
                  (item) => item.maqta_id === selectedCoord.coord_maqta
                )
              : null;
          const temp_maqra =
            dataMaqra !== null
              ? dataMaqra.find(
                  (item) => item.maqra_id === selectedCoord.coord_maqra
                )
              : null;

          setValue("coord_ayat", temp_ayat ?? null);
          setValue("coord_maqta", temp_maqta ?? null);
          setValue("coord_maqra", temp_maqra ?? null);
          setValue("coord_sequence", selectedCoord.coord_sequence ?? null);
        } catch (error) {
          console.log(error);
        }
      })();
    }
  }, [selectedCoord]);

  useEffect(() => {
    resetField("coord_ayat");
    resetField("coord_maqta");
    resetField("coord_maqra");
    resetField("coord_sequence");

    (async () => {
      setDisableFormAyat(true);
      setDisableFormMaqta(true);
      setDisableFormMaqra(true);
      setDisableFormSequence(true);

      if (watchCoordType !== "" && watchCoordType !== undefined) {
        try {
          if (
            watchCoordType.coordt_code === "AYAT" ||
            watchCoordType.coordt_code === "AYAT-FIRST" ||
            watchCoordType.coordt_code === "AYAT-LAST"
          ) {
            setDisableFormAyat(false);
          }

          if (
            watchCoordType.coordt_code === "MAQTA" ||
            watchCoordType.coordt_code === "MAQTA-FIRST" ||
            watchCoordType.coordt_code === "MAQTA-LAST" ||
            watchCoordType.coordt_code === "MAQTA-BODY"
          ) {
            setDisableFormMaqta(false);
          }

          if (watchCoordType.coordt_code === "MAQRA") {
            setDisableFormMaqra(false);
          }

          if (
            watchCoordType.coordt_code === "AYAT" ||
            watchCoordType.coordt_code === "MAQRA" ||
            watchCoordType.coordt_code === "MAQTA" ||
            watchCoordType.coordt_code === "MAQTA-BODY"
          ) {
            setDisableFormSequence(false);
          }
        } catch (error) {
          console.log(error);
        }
      }
    })();
  }, [watchCoordType]);

  useEffect(() => {
    // resetField_filter("customer");
    if (
      watchCoordMushaf !== null &&
      watchCoordMushaf !== undefined &&
      watchCoordPage !== null &&
      watchCoordPage !== undefined &&
      watchCoordType !== "" &&
      watchCoordType !== undefined
    ) {
      (async () => {
        try {
          await getCoord({
            bearertoken: bearertoken,
            mushaf: watchCoordMushaf,
            page: watchCoordPage,
            coord_type: watchCoordType,
          })
            .then((response) => {
              setDataCoord(response.data);
            })
            .catch((error) => {
              console.log(error);
            });
        } catch (error) {
          console.log(error);
        }
      })();
    }
  }, [watchCoordMushaf, watchCoordPage, watchCoordType]);

  const CanvasComponent = () => {
    const canvasRef = useRef(null);

    useEffect(() => {
      const canvas = canvasRef.current;
      const context = canvas.getContext("2d");
      // context.fillStyle = "red";
      // context.fillRect(50, 50, 100, 100);

      // Resize Canvas
      const resizeCanvas = () => {
        canvas.width = canvas.parentNode.clientWidth;
        canvas.height = canvas.parentNode.clientWidth * 1.4;
        drawRect();
      };
      const drawRect = () => {
        const image = new window.Image();

        if (optionShowPreview) {
          // image.src = require("../../assets/" +
          //   dataPageImage.pagei_mushaf +
          //   "/" +
          //   dataPageImage.pagei_filename +
          //   "." +
          //   dataPageImage.pagei_extension);
          image.crossOrigin = "anonymous";
          image.src = dataPageImage.pagei_url;
        } else {
          image.crossOrigin = "anonymous";
          image.src =
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/xcAArgBqRc8HigAAAAASUVORK5CYII=";
        }

        image.onload = () => {
          const borderWidth = 0.5;
          context.clearRect(0, 0, canvas.width, canvas.height);

          context.drawImage(image, 0, 0, canvas.width, canvas.height);

          context.fillStyle = "#84BBEA";
          // context.strokeStyle = "black";
          context.lineWidth = borderWidth;
          context.font = "bold 11px Arial";
          context.textAlign = "center";
          context.textBaseline = "middle";
          const colorPalette = [
            "#FFB3BA",
            "#FFDFBA",
            "#FFFFBA",
            "#BAFFC9",
            "#BAE1FF",
            "#E6CCFF",
            "#D5AAFF",
            "#B5EAD7",
            "#FFDAC1",
            "#C7CEEA",
            "#FFABAB",
            "#FFC3A0",
            "#FFDDC1",
            "#E2F0CB",
            "#B5EAD7",
            "#FFCBC1",
            "#FDCBFA",
            "#CBAACB",
            "#FFDEFA",
            "#D0F4DE",
            "#FFB347",
            "#D4A5A5",
            "#FFD3B6",
            "#A0E7E5",
            "#B4F8C8",
            "#FFAEBC",
            "#A0CED9",
            "#D8B5FF",
            "#F3C1C6",
            "#C3FBD8",
          ];
          const ayatColorMap = {};
          let colorIndex = 0;

          dataCoord.forEach((value) => {
            const {
              coord_left: temp_left,
              coord_top: temp_top,
              coord_right: temp_right,
              coord_bottom: temp_bottom,
              coord_ayat,
              coord_sequence,
              ayat_number,
            } = value;

            // Berikan warna untuk ayat yang belum dipetakan
            if (!(coord_ayat in ayatColorMap)) {
              ayatColorMap[coord_ayat] =
                colorPalette[colorIndex % colorPalette.length];
              colorIndex++;
            }

            const fillColor = hexToRgba(
              ayatColorMap[coord_ayat],
              optionShowPreview ? 0.4 : 1
            );

            const rectX = (canvas.width * temp_left) / 100;
            const rectY = (canvas.height * temp_top) / 100;
            const rectWidth = (canvas.width * (temp_right - temp_left)) / 100;
            const rectHeight = (canvas.height * (temp_bottom - temp_top)) / 100;

            context.fillStyle = fillColor;
            context.fillRect(rectX, rectY, rectWidth, rectHeight);

            context.strokeRect(
              rectX + borderWidth / 2,
              rectY + borderWidth / 2,
              rectWidth - borderWidth,
              rectHeight - borderWidth
            );

            const output = [
              showAyatId && `(${coord_ayat})`,
              showAyatNumber && `(${ayat_number})`,
              showSequence && `(${coord_sequence})`,
            ]
              .filter(Boolean)
              .join(" | ");

            context.fillStyle = "black";
            context.fillText(
              output,
              rectX + rectWidth / 2,
              rectY + rectHeight / 2
            );
          });
        };
      };

      resizeCanvas();
      window.addEventListener("resize", resizeCanvas);

      // Handler
      const handleClick = (event) => {
        const rect = canvas.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;

        dataCoord.forEach((value) => {
          const temp_left = value.coord_left;
          const temp_top = value.coord_top;
          const temp_right = value.coord_right;
          const temp_bottom = value.coord_bottom;

          const rectX = (canvas.width * temp_left) / 100;
          const rectY = (canvas.height * temp_top) / 100;
          const rectWidth = (canvas.width * (temp_right - temp_left)) / 100;
          const rectHeight = (canvas.height * (temp_bottom - temp_top)) / 100;

          if (
            x >= rectX &&
            x <= rectX + rectWidth &&
            y >= rectY &&
            y <= rectY + rectHeight
          ) {
            setSelectedCoord(value);
          }
        });
      };

      canvas.addEventListener("click", handleClick);

      return () => {
        canvas.removeEventListener("click", handleClick);
        window.removeEventListener("resize", resizeCanvas);
      };
    }, []);

    return (
      <div style={{ width: "100%", height: "100%" }}>
        <canvas ref={canvasRef} />
      </div>
    );
    // return <canvas ref={canvasRef} width={300} height={300} />;
  };

  const handleCropChange = (coordinate) => {
    setPreviewUrl("");
    setShowPreview(false);

    if (imageRef.current) {
      setCrop(coordinate);
      setLTRB({
        l: coordinate.x,
        t: coordinate.y,
        r: coordinate.x + coordinate.width,
        b: coordinate.y + coordinate.height,
      });
      setLTRB_Percentage({
        l: (coordinate.x / imageRef.current.width) * 100,
        t: (coordinate.y / imageRef.current.height) * 100,
        r: ((coordinate.x + coordinate.width) / imageRef.current.width) * 100,
        b: ((coordinate.y + coordinate.height) / imageRef.current.height) * 100,
      });

      setValue("coord_left", coordinate.x);
      setValue("coord_top", coordinate.y);
      setValue("coord_right", coordinate.x + coordinate.width);
      setValue("coord_bottom", coordinate.y + coordinate.height);

      setValue("coord_width", coordinate.width);
      setValue("coord_height", coordinate.height);

      setValue(
        "coord_left_percentage",
        (coordinate.x / imageRef.current.width) * 100
      );
      setValue(
        "coord_top_percentage",
        (coordinate.y / imageRef.current.height) * 100
      );
      setValue(
        "coord_right_percentage",
        ((coordinate.x + coordinate.width) / imageRef.current.width) * 100
      );
      setValue(
        "coord_bottom_percentage",
        ((coordinate.y + coordinate.height) / imageRef.current.height) * 100
      );
      setValue(
        "coord_aspect_ratio",
        imageRef.current.naturalHeight / imageRef.current.naturalWidth
      );
    }
  };

  const handleCropComplete = (coordinate) => {
    handleCropChange(coordinate);

    if (imageRef.current && coordinate.width && coordinate.height) {
      createImagePreview(coordinate);
      setShowPreview(true);
    }
  };

  const createImagePreview = (crop) => {
    const canvas = document.createElement("canvas");
    const scaleX = imageRef.current.naturalWidth / imageRef.current.width;
    const scaleY = imageRef.current.naturalHeight / imageRef.current.height;
    const canvasWidth = crop.width * scaleX;
    const canvasHeight = crop.height * scaleY;

    canvas.width = canvasWidth;
    canvas.height = canvasHeight;

    const ctx = canvas.getContext("2d");
    ctx.drawImage(
      imageRef.current,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      canvasWidth,
      canvasHeight
    );

    const previewURL = canvas.toDataURL("image/jpeg");
    setPreviewUrl(previewURL);
  };

  const selectedAyatTemplate = (option, props) => {
    if (option) {
      return (
        <div className="align-items-center flex">
          <div>{`[${option.surah_mstr_fk.surah_name}] - ${option.ayat_number}`}</div>
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };

  const AyatOptionTemplate = (option) => {
    return (
      <div className="align-items-center flex">
        <div>{`[${option.surah_mstr_fk.surah_name}] - ${option.ayat_number}`}</div>
      </div>
    );
  };

  return (
    <div className="flex flex-col overflow-hidden" style={{ height: "100svh" }}>
      <div className="flex-shrink-0">
        <Header hidden="true" />
      </div>
      <div className="grow overflow-hidden">
        <div className="grid h-full grid-cols-12 gap-0">
          <div className="col-span-9 flex flex-col">
            <div className="m-0 h-14 grow overflow-auto text-center">
              <ReactCrop
                crop={crop}
                onChange={handleCropChange}
                onComplete={handleCropComplete}
                style={{ width: "100%" }}
              >
                {dataPageImage !== null && (
                  <img
                    id="my-image"
                    ref={imageRef}
                    // src={require("../../assets/" +
                    //   dataPageImage.pagei_mushaf +
                    //   "/" +
                    //   dataPageImage.pagei_filename +
                    //   "." +
                    //   dataPageImage.pagei_extension)}
                    // // src={require("../../assets/" +
                    // //   dataPageImage.pagei_mushaf +
                    // //   "/" +
                    // //   "Tilawah Tajwid A6 Non Spot_potong-006" +
                    // //   "." +
                    // //   dataPageImage.pagei_extension)}
                    // // src={require("../../assets/MUSHAF-001/MINA__Page_005.jpg")}
                    crossOrigin="anonymous"
                    src={dataPageImage.pagei_url}
                    alt="Crop"
                    style={{ width: "100%", border: "1px solid" }}
                  />
                )}
              </ReactCrop>

              {/* <Dialog
                header="Preview"
                visible={showPreview}
                modal={false}
                style={{ width: "50vw" }}
                headerStyle={{ paddingTop: "10px", paddingBottom: "10px" }}
                onHide={() => setShowPreview(false)}
              >
                {previewUrl && (
                  <div
                    className="overflow-auto"
                    style={{ width: "100%", maxHeight: "20vh" }}
                  >
                    <Image
                      src={previewUrl}
                      alt="Preview Image"
                      width="100%"
                      preview
                      style={{
                        width: "100%",
                        border: "1px solid",
                      }}
                    />
                  </div>
                )}
              </Dialog> */}
            </div>
            <div
              className="flex-none overflow-auto p-4"
              style={{ width: "100%", minHeight: "20vh", maxHeight: "30vh" }}
            >
              {previewUrl && (
                <Image
                  src={previewUrl}
                  alt="Preview Image"
                  width="100%"
                  preview
                  style={{
                    width: "100%",
                    border: "1px solid",
                  }}
                />
              )}
            </div>
          </div>

          <div
            className="col-span-3 overflow-auto"
            style={{ backgroundColor: "#EAE1FF" }}
          >
            <div
              className="m-4 flex flex-col gap-4 p-4"
              style={{
                backgroundColor: "#FFFFFF",
                borderRadius: "10px",
              }}
            >
              <div className="card">
                <Accordion activeIndex={[0]} multiple>
                  <AccordionTab header="Konfigurasi" headerClassName="text-xs">
                    <div className="card justify-content-center flex flex-col gap-2">
                      {/* COORDINATE MUSHAF */}
                      <Controller
                        name="coord_mushaf"
                        control={control}
                        render={({ field, fieldState }) => (
                          <>
                            <div className="flex flex-col">
                              <Dropdown
                                id={field.name}
                                inputRef={field.ref}
                                value={field.value}
                                optionLabel="mushaf_name"
                                placeholder="Pilih Mushaf"
                                options={dataMushaf}
                                focusInputRef={field.ref}
                                onChange={(e) => field.onChange(e.value)}
                                filter
                                className={`h-6 w-full items-center lg:h-8 ${classNames(
                                  {
                                    "p-invalid": fieldState.error,
                                  }
                                )}`}
                              />
                              <FormErrorMessage
                                errors={errors}
                                name={field.name}
                              />
                            </div>
                          </>
                        )}
                      />

                      {/* COORDINATE PAGE */}
                      <Controller
                        name="coord_page"
                        control={control}
                        render={({ field, fieldState }) => (
                          <>
                            <div className="flex flex-col">
                              <Dropdown
                                id={field.name}
                                inputRef={field.ref}
                                value={field.value}
                                optionLabel="page_id"
                                placeholder="Pilih Halaman"
                                options={dataPage}
                                focusInputRef={field.ref}
                                onChange={(e) => field.onChange(e.value)}
                                filter
                                className={`h-6 w-full items-center lg:h-8 ${classNames(
                                  {
                                    "p-invalid": fieldState.error,
                                  }
                                )}`}
                              />
                              <FormErrorMessage
                                errors={errors}
                                name={field.name}
                              />
                            </div>
                          </>
                        )}
                      />

                      {/* COORDINATE TYPE */}
                      <Controller
                        name="coord_type"
                        control={control}
                        render={({ field, fieldState }) => (
                          <>
                            <div className="flex flex-col">
                              <Dropdown
                                id={field.name}
                                inputRef={field.ref}
                                value={field.value}
                                optionLabel="coordt_name"
                                placeholder="Pilih Tipe Koordinat"
                                options={dataCoordType}
                                focusInputRef={field.ref}
                                onChange={(e) => field.onChange(e.value)}
                                className={`h-6 w-full items-center lg:h-8 ${classNames(
                                  {
                                    "p-invalid": fieldState.error,
                                  }
                                )}`}
                              />
                              <FormErrorMessage
                                errors={errors}
                                name={field.name}
                              />
                            </div>
                          </>
                        )}
                      />
                    </div>
                  </AccordionTab>
                </Accordion>
              </div>
              {watchCoordType !== undefined && (
                <Button
                  className="p-inputgroup-addon h-6 !text-xs lg:h-8"
                  label="Lihat Indexing"
                  onClick={() => setShowIndexing(true)}
                />
              )}
              <div className="grid grid-cols-2 items-end gap-x-6 gap-y-2">
                {/* COORDINATE LEFT */}
                <div className="col-span-2">
                  <Controller
                    name="coord_left"
                    control={control}
                    render={({ field, fieldState }) => (
                      <>
                        <div className="flex flex-col">
                          <FormLabel label="Coordinate Left" />
                          <div className="p-inputgroup">
                            <span className="p-inputgroup-addon h-6 !text-xs lg:h-8">
                              {ltrb_percentage.l.toFixed(2)} %
                            </span>
                            <InputNumber
                              id={field.name}
                              inputRef={field.ref}
                              value={field.value}
                              min={0}
                              max={ltrb.r - 1}
                              onBlur={field.onBlur}
                              onValueChange={(e) => {
                                field.onChange(e);
                                const temp = crop;
                                temp.x = e.value;
                                temp.width = ltrb.r - e.value;
                                handleCropComplete(crop);
                              }}
                              useGrouping={false}
                              showButtons
                              inputClassName="!text-xs"
                              className={`h-6 lg:h-8 ${classNames({
                                "p-invalid": fieldState.error,
                              })}`}
                              suffix=" px"
                              locale="en-IN"
                              minFractionDigits={2}
                              disabled={
                                imageFound &&
                                watchCoordLeft !== null &&
                                watchCoordLeft !== undefined
                                  ? false
                                  : true
                              }
                            />
                          </div>
                          <FormErrorMessage errors={errors} name={field.name} />
                        </div>
                      </>
                    )}
                  />
                </div>

                {/* COORDINATE RIGHT */}
                <div className="col-span-2">
                  <Controller
                    name="coord_right"
                    control={control}
                    render={({ field, fieldState }) => (
                      <>
                        <div className="flex flex-col">
                          <FormLabel label="Coordinate Right" />
                          <div className="p-inputgroup">
                            <span className="p-inputgroup-addon h-6 !text-xs lg:h-8">
                              {ltrb_percentage.r.toFixed(2)} %
                            </span>
                            <InputNumber
                              id={field.name}
                              inputRef={field.ref}
                              value={field.value}
                              min={ltrb.l + 1}
                              max={imageRef.current && imageRef.current.width}
                              onBlur={field.onBlur}
                              onValueChange={(e) => {
                                field.onChange(e);
                                const temp = crop;
                                temp.width = e.value - ltrb.l;
                                handleCropComplete(crop);
                              }}
                              useGrouping={false}
                              showButtons
                              inputClassName="!text-xs"
                              className={`h-6 lg:h-8 ${classNames({
                                "p-invalid": fieldState.error,
                              })}`}
                              suffix=" px"
                              locale="en-IN"
                              minFractionDigits={2}
                              disabled={
                                imageFound &&
                                watchCoordRight !== null &&
                                watchCoordRight !== undefined
                                  ? false
                                  : true
                              }
                            />
                          </div>
                          <FormErrorMessage errors={errors} name={field.name} />
                        </div>
                      </>
                    )}
                  />
                </div>

                {/* COORDINATE TOP */}
                <div className="col-span-2">
                  <Controller
                    name="coord_top"
                    control={control}
                    render={({ field, fieldState }) => (
                      <>
                        <div className="flex flex-col">
                          <FormLabel label="Coordinate Top" />
                          <div className="p-inputgroup">
                            <span className="p-inputgroup-addon h-6 !text-xs lg:h-8">
                              {ltrb_percentage.t.toFixed(2)} %
                            </span>
                            <InputNumber
                              id={field.name}
                              inputRef={field.ref}
                              value={field.value}
                              min={0}
                              max={ltrb.b - 1}
                              onBlur={field.onBlur}
                              onValueChange={(e) => {
                                field.onChange(e);
                                const temp = crop;
                                temp.y = e.value;
                                temp.height = ltrb.b - e.value;
                                handleCropComplete(crop);
                              }}
                              useGrouping={false}
                              showButtons
                              inputClassName="!text-xs"
                              className={`h-6 lg:h-8 ${classNames({
                                "p-invalid": fieldState.error,
                              })}`}
                              suffix=" px"
                              locale="en-IN"
                              minFractionDigits={2}
                              disabled={
                                imageFound &&
                                watchCoordTop !== null &&
                                watchCoordTop !== undefined
                                  ? false
                                  : true
                              }
                            />
                          </div>
                          <FormErrorMessage errors={errors} name={field.name} />
                        </div>
                      </>
                    )}
                  />
                </div>

                {/* COORDINATE BOTTOM */}
                <div className="col-span-2">
                  <Controller
                    name="coord_bottom"
                    control={control}
                    render={({ field, fieldState }) => (
                      <>
                        <div className="flex flex-col">
                          <FormLabel label="Coordinate Bottom" />
                          <div className="p-inputgroup">
                            <span className="p-inputgroup-addon h-6 !text-xs lg:h-8">
                              {ltrb_percentage.b.toFixed(2)} %
                            </span>
                            <InputNumber
                              id={field.name}
                              inputRef={field.ref}
                              value={field.value}
                              min={ltrb.t + 1}
                              max={imageRef.current && imageRef.current.height}
                              onBlur={field.onBlur}
                              onValueChange={(e) => {
                                field.onChange(e);
                                const temp = crop;
                                temp.height = e.value - ltrb.t;
                                handleCropComplete(crop);
                              }}
                              useGrouping={false}
                              showButtons
                              inputClassName="!text-xs"
                              className={`h-6 lg:h-8 ${classNames({
                                "p-invalid": fieldState.error,
                              })}`}
                              suffix=" px"
                              locale="en-IN"
                              minFractionDigits={2}
                              disabled={
                                imageFound &&
                                watchCoordBottom !== null &&
                                watchCoordBottom !== undefined
                                  ? false
                                  : true
                              }
                            />
                          </div>
                          <FormErrorMessage errors={errors} name={field.name} />
                        </div>
                      </>
                    )}
                  />
                </div>

                {/* COORDINATE WIDTH */}
                <div className="col-span-1">
                  <Controller
                    name="coord_width"
                    control={control}
                    render={({ field, fieldState }) => (
                      <>
                        <div className="flex flex-col">
                          <FormLabel label="Width" />
                          <InputNumber
                            id={field.name}
                            inputRef={field.ref}
                            value={field.value}
                            onBlur={field.onBlur}
                            useGrouping={false}
                            inputClassName="!text-xs w-full"
                            className={`h-6 w-full lg:h-8 ${classNames({
                              "p-invalid": fieldState.error,
                            })}`}
                            disabled
                            suffix=" px"
                            locale="en-IN"
                            minFractionDigits={2}
                          />
                          <FormErrorMessage errors={errors} name={field.name} />
                        </div>
                      </>
                    )}
                  />
                </div>

                {/* COORDINATE HEIGHT */}
                <div className="col-span-1">
                  <Controller
                    name="coord_height"
                    control={control}
                    render={({ field, fieldState }) => (
                      <>
                        <div className="flex flex-col">
                          <FormLabel label="Height" />
                          <InputNumber
                            id={field.name}
                            inputRef={field.ref}
                            value={field.value}
                            onBlur={field.onBlur}
                            useGrouping={false}
                            inputClassName="!text-xs w-full"
                            className={`h-6 lg:h-8 ${classNames({
                              "p-invalid": fieldState.error,
                            })}`}
                            disabled
                            suffix=" px"
                            locale="en-IN"
                            minFractionDigits={2}
                          />
                          <FormErrorMessage errors={errors} name={field.name} />
                        </div>
                      </>
                    )}
                  />
                </div>

                {/* COORDINATE ASPECT RATION */}
                <div className="col-span-2">
                  <Controller
                    name="coord_aspect_ratio"
                    control={control}
                    render={({ field, fieldState }) => (
                      <>
                        <div className="flex flex-col">
                          <FormLabel label="Aspect Ratio [Height]" />
                          <InputNumber
                            id={field.name}
                            inputRef={field.ref}
                            value={field.value}
                            onBlur={field.onBlur}
                            useGrouping={false}
                            inputClassName="!text-xs"
                            className={`h-6 lg:h-8 ${classNames({
                              "p-invalid": fieldState.error,
                            })}`}
                            disabled
                            suffix=" %"
                            locale="en-IN"
                            minFractionDigits={2}
                          />
                          <FormErrorMessage errors={errors} name={field.name} />
                        </div>
                      </>
                    )}
                  />
                </div>

                {/* COORDINATE AYAT */}
                {!disableFormAyat && (
                  <div
                    className={`${classNames({
                      "col-span-1": !disableFormSequence,
                      "col-span-2": disableFormSequence,
                    })}`}
                  >
                    <Controller
                      name="coord_ayat"
                      control={control}
                      render={({ field, fieldState }) => (
                        <>
                          <div className="flex flex-col">
                            <FormLabel label="Ayat" />
                            <Dropdown
                              id={field.name}
                              inputRef={field.ref}
                              value={field.value}
                              valueTemplate={selectedAyatTemplate}
                              optionLabel="ayat_number"
                              itemTemplate={AyatOptionTemplate}
                              placeholder="Pilih Ayat"
                              options={dataAyat}
                              focusInputRef={field.ref}
                              onChange={(e) => field.onChange(e.value)}
                              className={`h-6 w-full items-center lg:h-8 ${classNames(
                                {
                                  "p-invalid": fieldState.error,
                                }
                              )}`}
                              disabled={
                                imageRef.current ? disableFormAyat : true
                              }
                            />
                            <FormErrorMessage
                              errors={errors}
                              name={field.name}
                            />
                          </div>
                        </>
                      )}
                    />
                  </div>
                )}

                {/* COORDINATE MAQTA */}
                {!disableFormMaqta && (
                  <div
                    className={`${classNames({
                      "col-span-1": !disableFormSequence,
                      "col-span-2": disableFormSequence,
                    })}`}
                  >
                    <Controller
                      name="coord_maqta"
                      control={control}
                      render={({ field, fieldState }) => (
                        <>
                          <div className="flex flex-col">
                            <FormLabel label="Nomor Maqta" />
                            <Dropdown
                              id={field.name}
                              inputRef={field.ref}
                              value={field.value}
                              optionLabel="maqta_number"
                              placeholder="Pilih Nomor Maqta"
                              options={dataMaqta}
                              focusInputRef={field.ref}
                              onChange={(e) => field.onChange(e.value)}
                              className={`h-6 w-full items-center lg:h-8 ${classNames(
                                {
                                  "p-invalid": fieldState.error,
                                }
                              )}`}
                              disabled={
                                imageRef.current ? disableFormMaqta : true
                              }
                            />
                            <FormErrorMessage
                              errors={errors}
                              name={field.name}
                            />
                          </div>
                        </>
                      )}
                    />
                  </div>
                )}

                {/* COORDINATE MAQRA */}
                {!disableFormMaqra && (
                  <div
                    className={`${classNames({
                      "col-span-1": !disableFormSequence,
                      "col-span-2": disableFormSequence,
                    })}`}
                  >
                    <Controller
                      name="coord_maqra"
                      control={control}
                      render={({ field, fieldState }) => (
                        <>
                          <div className="flex flex-col">
                            <FormLabel label="Nomor Maqra" />
                            <Dropdown
                              id={field.name}
                              inputRef={field.ref}
                              value={field.value}
                              optionLabel="maqra_number"
                              placeholder="Pilih Nomor Maqra"
                              options={dataMaqra}
                              focusInputRef={field.ref}
                              onChange={(e) => field.onChange(e.value)}
                              className={`h-6 w-full items-center lg:h-8 ${classNames(
                                {
                                  "p-invalid": fieldState.error,
                                }
                              )}`}
                              disabled={
                                imageRef.current ? disableFormMaqra : true
                              }
                            />
                            <FormErrorMessage
                              errors={errors}
                              name={field.name}
                            />
                          </div>
                        </>
                      )}
                    />
                  </div>
                )}

                {/* COORDINATE SEQUENCE */}
                {!disableFormSequence && (
                  <div className="col-span-1">
                    <Controller
                      name="coord_sequence"
                      control={control}
                      render={({ field, fieldState }) => (
                        <>
                          <div className="flex flex-col">
                            <FormLabel label="Urutan Crop" />
                            <InputNumber
                              id={field.name}
                              inputRef={field.ref}
                              value={field.value}
                              min={1}
                              max={20}
                              onBlur={field.onBlur}
                              onValueChange={(e) => field.onChange(e)}
                              useGrouping={false}
                              showButtons
                              inputClassName="!text-xs w-full"
                              className={`h-6 lg:h-8 ${classNames({
                                "p-invalid": fieldState.error,
                              })}`}
                            />
                            <FormErrorMessage
                              errors={errors}
                              name={field.name}
                            />
                          </div>
                        </>
                      )}
                    />
                  </div>
                )}
              </div>
              <div className="mt-4 flex gap-2">
                <Button
                  type="submit"
                  label="Reset"
                  icon="pi pi-times" // Icon
                  size="small" // Size
                  // text // API
                  className="h-6 !text-xs "
                  // onClick={() => reset_filter()}
                />
                <Button
                  type="submit"
                  label="Submit"
                  icon="pi pi-check" // Icon
                  size="small" // Size
                  // autoFocus // API
                  className="h-6 !text-xs "
                  // className="h-6 flex-1 !text-xs lg:h-8"
                  // style={{ marginTop: "1rem" }}
                  onClick={SubmitCoord}
                />
                <Button
                  type="delete"
                  label="Delete"
                  icon="pi pi-delete" // Icon
                  size="small" // Size
                  // autoFocus // API
                  className="h-6 !text-xs "
                  // className="h-6 flex-1 !text-xs lg:h-8"
                  // style={{ marginTop: "1rem" }}
                  onClick={DeleteCoord}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Sidebar
        visible={showIndexing}
        position="right"
        onHide={() => setShowIndexing(false)}
      >
        <div>
          <CanvasComponent />

          <div class="mb-2 mt-2 block p-2 text-center">
            <Checkbox
              inputId="show_preview"
              onChange={(e) => setOptionShowPreview(e.checked)}
              checked={optionShowPreview}
            />
            <label htmlFor="show_preview" className="ml-2">
              Show Preview
            </label>
          </div>

          <div class="mb-2 block p-2 text-center">
            <Checkbox
              inputId="show_ayat_id"
              onChange={(e) => setShowAyatId(e.checked)}
              checked={showAyatId}
            />
            <label htmlFor="show_ayat_id" className="ml-2">
              Show Ayat ID
            </label>
          </div>

          <div class="mb-2 block p-2 text-center">
            <Checkbox
              inputId="show_ayat_number"
              onChange={(e) => setShowAyatNumber(e.checked)}
              checked={showAyatNumber}
            />
            <label htmlFor="show_ayat_number" className="ml-2">
              Show Ayat Number
            </label>
          </div>

          <div class="mb-2 block p-2 text-center">
            <Checkbox
              inputId="show_sequence"
              onChange={(e) => setShowSequence(e.checked)}
              checked={showSequence}
            />
            <label htmlFor="show_sequence" className="ml-2">
              Show Sequence
            </label>
          </div>

          <Paginator
            first={
              watchCoordPage !== undefined ? watchCoordPage.page_id - 1 : 0
            }
            rows={1}
            totalRecords={604}
            onPageChange={(e) => {
              const selectedPage = dataPage.find(
                (item) => item.page_id === e.page + 1
              );
              setValue("coord_page", selectedPage);
            }}
            // onPageChange={onPageChange}
            template={{ layout: "PrevPageLink CurrentPageReport NextPageLink" }}
          />
        </div>
      </Sidebar>

      <Toast ref={toast} position="bottom-right" />
      <ConfirmDialog />
    </div>
  );
}
